import React from 'react';

import classnames from 'classnames';

import styles from './LineItem.scss';

interface LineItemProps {
    className?: string;
    leftCol?: React.ReactNode;
    leftColStyles?: string;
    rightCol?: React.ReactNode;
    rightColStyles?: string;
}

function LineItem(props: LineItemProps) {
    const {
        className,
        leftCol,
        leftColStyles,
        rightCol,
        rightColStyles,
    } = props;

    return (
        <div className={classnames(styles.row, className)}>
            <div className={leftColStyles}>
                {leftCol}
            </div>
            <div className={classnames(styles.rightCol, rightColStyles)}>
                {rightCol}
            </div>
        </div>
    );
}

export { LineItem };
